module.exports = __webpack_public_path__ + "img/BLUE.127d2993.jpg";